module.exports = __webpack_public_path__ + "img/228.32f7bbae.jpg";